import React from 'react';
import {useHistory} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import MenuItem from '@ey/motif-react-wrapper/MenuItem';
import {labels} from '../../../util/uiconstants';
import env from '../../../util/env';
import Utility from '../../../util/utils';
import {logoutUser} from '../../../actions/timeoutactions';
import {adobeAnalytics} from '@ey/voltron-analytics';
import {clickActionArgs} from '../../Common/Adobe Analytics/actionHelpers.js';
import {
	eventTypes,
	controlTypes,
	locationInPages,
	clickActionNames,
	webInteractionTypes
} from '../Adobe Analytics/constants';
import {useQualtrics} from '@ey/canvascoreservices/Qualtrics';

const MoreMenuOptions = (props) => {
	const {featureConfiguration, userSettings} = props;

	const history = useHistory();
	const dispatch = useDispatch();
	const trackEvent = adobeAnalytics.useAdobeAnalyticsTrack();

	const qualtricsProjectId = featureConfiguration?.qualtricsprojectid;
	const showQualtricsLink = qualtricsProjectId && featureConfiguration?.isqualtricsenabled;
	const qualtricsInterceptAPI = useQualtrics(qualtricsProjectId);
	
	const onLeaveUsFeedbackClick = () => {
		qualtricsInterceptAPI((API) => {
			API.unload();
			API.load().done(runQualtricsIntercept);
		});
	};

	const runQualtricsIntercept = () => {
		qualtricsInterceptAPI((API) => {
			API.run();
			window.dispatchEvent(new CustomEvent('closeMenu', {}));
		});
	};

	const trackClickAction = (name, url = undefined) => {
		// Adobe Analytics Click Tracking
		trackEvent(
			eventTypes.clickAction,
			clickActionArgs(
				name,
				controlTypes.button,
				locationInPages.leftNav,
				url,
				name === clickActionNames.generalHelp && clickActionNames.logout
					? webInteractionTypes.exit
					: webInteractionTypes.other
			)
		);
	};

	const onUserSettingsClick = () => {
		trackClickAction(
			clickActionNames.userSettings,
			`${window.location.origin}/usersettings`
		);
		window.dispatchEvent(new CustomEvent('closeMenu', {}));
		history.push('/usersettings');
	};

	const onLogoutClick = () => {
		trackClickAction(clickActionNames.logout);
		dispatch(logoutUser());
	};

	let paansConfiguration = env.getPaansConfiguration();

	if (paansConfiguration) {
		const userLanguageCode = Utility.GetUserLanguageCode(
			userSettings.userlanguageid
		);
		paansConfiguration.paansUrl =
			paansConfiguration.paansUrl + `&l=${userLanguageCode}`;
	}

	return (
		<>
			{featureConfiguration?.iseycanvaseconomicsenabled &&
				!userSettings?.isguestuser && (
					<MenuItem
						onClick={() => {
							trackClickAction(
								clickActionNames.eyCanvasEconomics,
								featureConfiguration?.eycanvaseconomicsurl
							);
						}}
					>
						<a href={featureConfiguration?.eycanvaseconomicsurl || ''}>
							<span>{labels.eyCanvasEconomicsTooltip}</span>
						</a>
					</MenuItem>
				)}
			{featureConfiguration?.iseyoversightenabled &&
				!userSettings?.isguestuser && (
					<MenuItem
						onClick={() => {
							trackClickAction(
								clickActionNames.eyCanvasOversight,
								featureConfiguration?.eycanvasoversighturl
							);
						}}
					>
						<a href={featureConfiguration?.eycanvasoversighturl || ''}>
							<span>{labels.eyOversightTooltip}</span>
						</a>
					</MenuItem>
				)}
			{featureConfiguration?.eyassuranceserviceurl &&
				!userSettings?.isguestuser && (
					<MenuItem
						onClick={() => {
							trackClickAction(
								clickActionNames.eyCanvasAssurance,
								featureConfiguration?.eyassuranceserviceurl
							);
						}}
					>
						<a href={featureConfiguration?.eyassuranceserviceurl || ''}>
							<span>{labels.eyAssuranceDeliverablesTooltip}</span>
						</a>
					</MenuItem>
				)}
			<MenuItem
				onClick={() => {
					trackClickAction(clickActionNames.generalHelp, env.getHelpWebUrl());
				}}
			>
				<a href={env.getHelpWebUrl()} target="_blank">
					<span>{labels.eyGeneralHelp}</span>
				</a>
			</MenuItem>
			{userSettings.isguestuser != undefined && (
				<MenuItem>
					<a onClick={onUserSettingsClick}>
						<span>{labels.usersettings}</span>
					</a>
				</MenuItem>
			)}
			{paansConfiguration?.paansEnabled &&
				paansConfiguration.privacyNoticePolicyTypeId && (
					<MenuItem
						onClick={() => {
							trackClickAction(
								clickActionNames.privacyNotice,
								paansConfiguration?.paansUrl +
									`&pt=${paansConfiguration?.privacyNoticePolicyTypeId}`
							);
						}}
					>
						<a
							href={
								paansConfiguration?.paansUrl +
								`&pt=${paansConfiguration?.privacyNoticePolicyTypeId}`
							}
							target="_blank"
						>
							<span>{labels.eyPrivacyNoticeTooltip}</span>
						</a>
					</MenuItem>
				)}
			{paansConfiguration?.paansEnabled &&
				paansConfiguration?.termsOfServicePolicyTypeId && (
					<MenuItem
						onClick={() => {
							trackClickAction(
								clickActionNames.termsOfService,
								paansConfiguration?.paansUrl +
									`&pt=${paansConfiguration?.termsOfServicePolicyTypeId}`
							);
						}}
					>
						<a
							href={
								paansConfiguration?.paansUrl +
								`&pt=${paansConfiguration?.termsOfServicePolicyTypeId}`
							}
							target="_blank"
						>
							<span>{labels.eyTermsOfServiceTooltip}</span>
						</a>
					</MenuItem>
				)}
			{(userSettings.isguestuser || userSettings.isguestuser === undefined) && (
				<MenuItem>
					<a onClick={onLogoutClick}>
						<span>{labels.logout}</span>
					</a>
				</MenuItem>
			)}
			{(showQualtricsLink && qualtricsProjectId) && (
				<MenuItem
					onClick={() => {
						trackClickAction(clickActionNames.leaveUsFeedback);
					}}
				>
					<a onClick={onLeaveUsFeedbackClick}>
						<span>{labels.eyLeaveUsFeedback}</span>
					</a>
				</MenuItem>
			)}
		</>
	);
};

export default MoreMenuOptions;
